<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
            <button class="sk-btn sk-btn-primary rounded-lg" @click="handleCreate">
                {{ $t('apps.campaigns.form.createButton') }}
            </button>
        </template>
        <template v-slot:datatable>
            <DataTable
                :config="datatableConfig"
                :elements="mapboxAccounts"
                :stripe="true"
                :draggable="false"
                :sst="true"
                :pagination="pagination"
                @action="handleAction"
                @filter="handleFilter"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import { v4 as uuidv4 } from 'uuid';
import loader from "@/modules/Shared/Mixins/loader";
import DataTable from "@/modules/Shared/Components/table/SKDataTable.vue";
import PaginationService from "@/modules/Shared/Services/PaginationService";
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout.vue";
import MapboxAccountsService from "@/modules/Admin/Services/MapboxAccountsService";

export default {
    name: "MapboxAccountsPage",
    components: { DataTable, DatatablePageLayout },
    mixins: [loader],
    data() {
        return {
            mapboxAccounts: [],
            datatableConfig: [
                { 'field' : 'username', head : this.$t('admin.mapbox-accounts.username'), 'searchable' : true, 'sortable' : false},
                { 'field' : 'account_email', head : this.$t('admin.mapbox-accounts.email'), 'searchable' : true, 'sortable' : false},
                { 'field' : 'actions', 'type': 'actions', head : this.$t("geofences.geofences-messages.actions"), 'searchable' : false, 'sortable' : false }
            ],
            pagination: {},
        }
    },
    async created() {
        await this.loadAndNotifyError(async () => {
            await this.getMapboxAccounts({
                filters: [],
                page: 1
            })
        })
    },
    methods: {
        async getMapboxAccounts(params) {
            const mapboxAccountsResponse = await MapboxAccountsService.getMapboxAccounts(PaginationService.parseParameters(params))
            this.mapboxAccounts = this.parseMapboxAccounts(mapboxAccountsResponse.data)
            this.pagination = {
                per_page: mapboxAccountsResponse.per_page,
                total: mapboxAccountsResponse.total
            }
        },

        parseMapboxAccounts(mapboxAccounts) {
            return mapboxAccounts.map(mapboxAccount => ({
                ...mapboxAccount,
                actions: [ 'edit', 'delete' ]
            }))
        },

        async handleFilter(params) {
            await this.getMapboxAccounts(params)
        },

        async handleAction(type, uuid){
            switch(type) {
                case 'edit':
                    await this.$router.push({
                        name: 'admin-mapbox-accounts-edit',
                        params: { uuid: uuid }
                    })
                    break
                case 'delete':
                    await this.deleteMapboxAccount(uuid)
                    break
            }
        },

        async handleCreate() {
            await this.$router.push({
                name: 'admin-mapbox-accounts-edit',
                params: { uuid: uuidv4() }
            })
        },

        async deleteMapboxAccount(uuid) {
            await this.loadAndNotify(async () => {
                await MapboxAccountsService.deleteMapboxAccount(uuid)
                await this.getMapboxAccounts({ filters: [], page: 1 })
            })
        }
    }
};
</script>
